
import AOSInitializer from "../../AOSInitializer"
export const ContentWritingCards = () => {

    return (
        <div className="row">
        {/* card 01 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content1.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_Services">
                    Blog Writing
                  </a>
                </h3>
                <p>
                  Creating informative and engaging blog posts that help boost
                  SEO, provide value to readers, and position the company as an
                  industry leader.
                </p>
                <a href="/Content_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 02 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content2.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_Services">
                    SEO Content Writing
                  </a>
                </h3>
                <p>
                  Producing content optimized for search engines to improve
                  visibility and drive organic traffic to the website.
                </p>
                <a href="/Content_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 03 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content3.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_Services">
                    Copywriting for Advertising
                  </a>
                </h3>
                <p>
                  Crafting persuasive copy for advertisements, including print
                  ads, online ads, and commercials to compel action from the
                  target audience.
                </p>
                <a href="/Content_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 04 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content4.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_sub_Services">
                    Social Media Posts
                  </a>
                </h3>
                <p>
                  Writing tailored content for different social media platforms
                  such as LinkedIn, Instagram, and Twitter to engage with
                  followers and promote brand messaging.
                </p>
                <a href="/Content_sub_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 05 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-zoom-in">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content5.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_sub_Services">
                    Email Marketing Campaigns
                  </a>
                </h3>
                <p>
                  Developing targeted email content for promotional campaigns or
                  regular newsletters to keep subscribers informed and engaged.
                </p>
                <a href="/Content_sub_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 06 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-zoom-in">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content6.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_sub_Services">
                    Technical Writing
                  </a>
                </h3>
                <p>
                  Developing targeted email content for promotional campaigns or
                  regular newsletters to keep subscribers informed and engaged.
                </p>
                <a href="/Content_sub_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 07 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-zoom-in">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content7.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_sub_Services">
                    White Papers
                  </a>
                </h3>
                <p>
                  Writing detailed and authoritative reports or guides on
                  particular topics that highlight expertise and generate leads.
                </p>
                <a href="/Content_sub_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 08 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content8.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_sub_Services">
                    Product Descriptions
                  </a>
                </h3>
                <p>
                  Creating compelling and informative descriptions for
                  e-commerce websites to enhance product appeal and boost sales.
                </p>
                <a href="/Content_sub_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 09 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content-web1.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_sub_Services">
                    Ghostwriting
                  </a>
                </h3>
                <p>
                  Writing content such as articles, speeches, or books on behalf
                  of another person, maintaining their voice and style.
                </p>
                <a href="/Content_sub_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 10 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/content10.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Content_sub_Services">
                    Storytelling
                  </a>
                </h3>
                <p>
                  Crafting narratives that weave key brand messages into stories
                  to connect emotionally with the audience, often used in brand
                  campaigns and&nbsp;video&nbsp;scripts.
                </p>
                <a href="/Content_sub_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}